import "../styles/stats-panel.css"

export default function StatsPanel({ cities, totalDistance, step, maxSteps, algorithm }) {
  const percent = maxSteps ? Math.round((step / maxSteps) * 100) : 0

  return (
    <div className="stats-panel">
      <h3>Statistics</h3>

      <div className="stat-item">
        <span className="stat-label">Cities</span>
        <span className="stat-value">{cities.length}</span>
      </div>

      <div className="stat-item">
        <span className="stat-label">Algorithm</span>
        <span className="stat-value">{algorithm}</span>
      </div>

      <div className="stat-item">
        <span className="stat-label">Total Distance</span>
        <span className="stat-value">{totalDistance}</span>
      </div>

      <div className="stats-progress">
        <div className="stats-progress-header">
          <span className="stats-progress-label">Progress</span>
          <span className="stats-progress-value">
            {step} / {maxSteps}&nbsp;&nbsp;{percent}%
          </span>
        </div>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${percent}%` }} />
        </div>
      </div>
    </div>
  )
}
